import React from 'react';
const WellnessPrograms = () => <div className="service-page"><h1>Wellness Programs</h1><p>Join wellness programs for a healthier lifestyle.</p></div>;
export default WellnessPrograms;
